import type { SupabaseClient } from '@supabase/supabase-js'
import type { AuthProvider } from 'react-admin'

import type { Database } from '@/data'

export const createAuthProvider = (supabase: SupabaseClient<Database>): AuthProvider => ({
  login: async ({ username, password }: { username: string; password: string }) => {
    const { error } = await supabase.auth.signInWithPassword({ email: username, password })
    if (error) throw new Error(error.message)
  },

  logout: async () => {
    const { error } = await supabase.auth.signOut()
    if (error) console.error('Error during sign out:', error)
  },

  checkError: ({ status }: { status: number }) => {
    if (status === 401 || status === 403) {
      void supabase.auth.signOut()
      return Promise.reject(new Error('Unauthorized'))
    }
    return Promise.resolve()
  },

  checkAuth: async () => {
    const { data } = await supabase.auth.getSession()
    if (!data.session) throw new Error('No active session')
  },

  getPermissions: async () => {
    const { data } = await supabase.auth.getSession()
    return data.session?.user.role ?? ''
  },

  getIdentity: async () => {
    const { data } = await supabase.auth.getSession()
    if (!data.session?.user) throw new Error('No active session')
    return { id: data.session.user.id, fullName: data.session.user.email ?? '', avatar: undefined }
  },
})
